/* ezink-inventory.js — stock badge + live size-qty stock by color */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function parseInv(sectionId) {
    var qtyMap = {};
    var byOptions = {};
    var priceMap = {};
    var jsonEl = sectionId ? document.getElementById('VariantInventoryJson-' + sectionId) : document.querySelector('[id^="VariantInventoryJson-"]');
    if (jsonEl) {
      try {
        var data = JSON.parse((jsonEl.textContent || '').trim() || '{}');
        if (data && data.qty && typeof data.qty === 'object') {
          qtyMap = data.qty;
          byOptions = data.byOptions || {};
          priceMap = data.price || {};
        } else if (data && typeof data === 'object') {
          qtyMap = data;
        }
      } catch (e) {}
    }
    var pj = sectionId ? document.getElementById('ProductJson-' + sectionId) : document.querySelector('[id^="ProductJson-"]');
    var optionNames = [];
    if (pj) {
      try {
        var prod = JSON.parse((pj.textContent || '').trim() || '{}');
        optionNames = prod.options || [];
        (prod.variants || []).forEach(function (v) {
          var opts = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
          var k = opts.join('|');
          if (k && !byOptions[k]) byOptions[k] = String(v.id);
          if (v.id != null && v.inventory_quantity != null && qtyMap[String(v.id)] == null) {
            qtyMap[String(v.id)] = v.inventory_quantity;
          }
          if (v.id != null && v.price != null && priceMap[String(v.id)] == null) {
            priceMap[String(v.id)] = v.price;
          }
        });
      } catch (e2) {}
    }
    return { qtyMap: qtyMap, byOptions: byOptions, optionNames: optionNames, priceMap: priceMap };
  }

  function parseCloseout(sectionId) {
    var jsonEl = sectionId
      ? document.getElementById('CloseoutJson-' + sectionId)
      : document.querySelector('[id^="CloseoutJson-"]');
    var empty = { byOptions: {}, bySku: {}, byId: {} };
    if (!jsonEl) return empty;
    try {
      var data = JSON.parse((jsonEl.textContent || '').trim() || '{}') || {};
      return {
        byOptions: data.byOptions || {},
        bySku: data.bySku || {},
        byId: data.byId || {}
      };
    } catch (e) {
      return empty;
    }
  }

  function isCloseout(sectionId, color, size, vid) {
    var co = parseCloseout(sectionId);
    var opts = co.byOptions || {};
    if (color && size) {
      if (opts[color + '|' + size] || opts[size + '|' + color]) return true;
    }
    var ids = co.byId || {};
    if (vid != null && vid !== '') {
      var key = String(vid);
      if (ids[key] || ids[key.split('/').pop()]) return true;
    }
    return false;
  }

  window.ezinkCloseoutMap = parseCloseout;
  window.ezinkIsCloseout = isCloseout;

  function syncCloseoutNote(sectionId) {
    var root = liveRoot(sectionId);
    var note = root.querySelector('[data-ezink-closeout-note]');
    if (!note) return;
    if (root.getAttribute('data-ezink-closeout') === '1') {
      note.hidden = false;
      return;
    }
    var show = false;
    root.querySelectorAll('[data-ezink-size-qty-input]').forEach(function (inp) {
      if (inp.disabled) return;
      var n = parseInt(inp.value, 10) || 0;
      if (n < 1) return;
      if (inp.getAttribute('data-ezink-closeout') === '1') show = true;
    });
    note.hidden = !show;
  }

  function qtyForId(qtyMap, id) {
    if (id == null || id === '') return null;
    var key = String(id);
    if (Object.prototype.hasOwnProperty.call(qtyMap, key)) return qtyMap[key];
    if (key.indexOf('/') !== -1) {
      var tail = key.split('/').pop();
      if (Object.prototype.hasOwnProperty.call(qtyMap, tail)) return qtyMap[tail];
    }
    return null;
  }

  function findVid(byOptions, color, size) {
    if (!byOptions || !color || !size) return '';
    var tries = [color + '|' + size, size + '|' + color];
    var i;
    for (i = 0; i < tries.length; i++) {
      if (byOptions[tries[i]]) return String(byOptions[tries[i]]);
    }
    var prefix = color + '|';
    var k;
    for (k in byOptions) {
      if (!Object.prototype.hasOwnProperty.call(byOptions, k)) continue;
      if (k.indexOf(prefix) === 0 && k.slice(prefix.length) === size) return String(byOptions[k]);
    }
    return '';
  }

  function liveRoot(sectionId) {
    return (
      (sectionId && document.getElementById('ProductSection-' + sectionId)) ||
      document.querySelector('[data-section-type="product"]') ||
      document
    );
  }

  function liveColor(sectionId, optionNames) {
    var root = liveRoot(sectionId);
    var sw = root.querySelector('.ezink-pdp-swatch.is-selected');
    if (sw && sw.getAttribute('data-color')) return sw.getAttribute('data-color');
    var label = root.querySelector('[data-ezink-selected-color]');
    if (label && label.textContent.trim()) return label.textContent.trim();
    var sel = root.querySelector('[data-ezink-color-select]');
    if (sel && sel.value) return sel.value;
    var ps = sectionId ? document.getElementById('ProductSelect-' + sectionId) : root.querySelector('[data-product-select], select.product-form__variants');
    if (ps && ps.selectedIndex >= 0) {
      var txt = (ps.options[ps.selectedIndex].textContent || '').split(' - ')[0];
      var parts = txt.split('/').map(function (s) { return s.trim(); });
      var ci = 0;
      (optionNames || []).forEach(function (n, idx) {
        if (String(n).toLowerCase() === 'color' || String(n).toLowerCase() === 'colour') ci = idx;
      });
      if (parts[ci]) return parts[ci];
    }
    return '';
  }

  function colorFromVariant(v, optionNames) {
    if (!v) return '';
    var names = optionNames || [];
    var i;
    for (i = 0; i < names.length; i++) {
      var n = String(names[i] || '').toLowerCase();
      if (n === 'color' || n === 'colour') {
        if (v.options && v.options[i]) return v.options[i];
        return v['option' + (i + 1)] || '';
      }
    }
    return (v.options && v.options[0]) || v.option1 || '';
  }

  function bindSizeQtyStock(sectionId) {
    if (bindSizeQtyStock.bound) return;
    bindSizeQtyStock.bound = true;
    var inv = parseInv(sectionId);
    var painting = false;

    function paint(forcedColor) {
      var grid = liveRoot(sectionId).querySelector('[data-ezink-size-qty-grid]');
      if (!grid) return;
      var color = forcedColor || liveColor(sectionId, inv.optionNames);
      if (!color) return;
      if (painting) return;
      if (grid.getAttribute('data-ezink-size-qty-color') === color && grid.querySelector('.ezink-size-qty__stock')) return;
      painting = true;
      try {
        var prev = {};
        grid.querySelectorAll('[data-ezink-size-qty-input]').forEach(function (inp) {
          prev[inp.getAttribute('data-size') || ''] = inp.value;
        });
        var sizes = [];
        var sizeSel = liveRoot(sectionId).querySelector('[data-ezink-size-select]');
        if (sizeSel) {
          Array.prototype.forEach.call(sizeSel.options, function (opt) {
            if (opt.value) sizes.push(opt.value);
          });
        }
        if (!sizes.length) {
          var pfx = color + '|';
          Object.keys(inv.byOptions).forEach(function (k) {
            if (k.indexOf(pfx) === 0) sizes.push(k.slice(pfx.length));
          });
        }
        var html = '';
        sizes.forEach(function (size) {
          if (!size) return;
          var vid = findVid(inv.byOptions, color, size);
          if (!vid) return;
          var q = qtyForId(inv.qtyMap, vid);
          var n = q == null ? null : parseInt(q, 10);
          var sold = n != null && !isNaN(n) && n <= 0;
          var closeout = isCloseout(sectionId, color, size, vid);
          var stock = n == null || isNaN(n) ? '' : sold ? 'Sold out' : Number(n).toLocaleString();
          var saved = prev[size];
          var val = sold ? '0' : (saved != null && saved !== '' ? saved : '0');
          var priceCents = qtyForId(inv.priceMap || {}, vid);
          var priceAttr = '';
          if (priceCents != null) {
            var pc = parseInt(priceCents, 10);
            if (!isNaN(pc) && pc > 0) priceAttr = 'data-price="' + pc + '" ';
          }
          var title = sold ? 'Sold out' : (closeout ? 'Closeout — while supplies last' : (stock ? stock + ' in stock' : ''));
          var stockHtml = '';
          if (sold) {
            stockHtml += '<button type="button" class="ezink-size-qty__stock ezink-size-qty__sold-link" data-ezink-open-soldout aria-label="Open Sold Out Assistant">Sold out</button>';
          } else if (stock) {
            stockHtml += '<span class="ezink-size-qty__stock">' + stock + '</span>';
          }
          if (closeout && !sold) stockHtml += '<span class="ezink-size-qty__closeout">Closeout</span>';
          html +=
            '<label class="ezink-size-qty__row' + (sold ? ' is-sold' : '') + (closeout ? ' is-closeout' : '') + '"' +
            (title ? ' title="' + title + '"' : '') + '>' +
            size +
            '<input class="product-form__input" type="number" min="0" step="1" inputmode="numeric" ' +
            'data-ezink-size-qty-input data-size="' + size.replace(/"/g, '&quot;') + '" data-variant-id="' + vid + '" ' +
            (closeout ? 'data-ezink-closeout="1" ' : '') +
            priceAttr +
            (sold ? 'disabled ' : '') +
            (n != null && n > 0 && n < 1000 ? 'max="' + n + '" ' : '') +
            'value="' + val + '" aria-label="Quantity for ' + size.replace(/"/g, '') + '">' +
            stockHtml +
            '</label>';
        });
        grid.setAttribute('data-ezink-size-qty-color', color);
        grid.innerHTML = html || '<p class="ezink-size-qty__help">No sizes for this color.</p>';
        if (window.ezinkSizeQty && typeof window.ezinkSizeQty.rebuild === 'function') {
          /* keep closed-over grid in product script in sync if it still points here */
        }
        syncCloseoutNote(sectionId);
        document.dispatchEvent(new CustomEvent('ezink-size-qty-rebuilt', { detail: { color: color } }));
      } finally {
        painting = false;
      }
    }

    function schedule(color) {
      setTimeout(function () { paint(color); }, 0);
      setTimeout(function () { paint(color); }, 50);
    }

    document.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (!t) return;
        if (t.hasAttribute && t.hasAttribute('data-ezink-size-qty-input')) {
          syncCloseoutNote(sectionId);
        }
        if (
          (t.hasAttribute && t.hasAttribute('data-ezink-color-select')) ||
          (t.classList && t.classList.contains('single-option-selector')) ||
          (t.id && t.id.indexOf('ProductSelect-') === 0)
        ) {
          schedule();
        }
      },
      true
    );
    document.addEventListener(
      'input',
      function (e) {
        var t = e.target;
        if (t && t.hasAttribute && t.hasAttribute('data-ezink-size-qty-input')) {
          syncCloseoutNote(sectionId);
        }
      },
      true
    );
    document.addEventListener(
      'click',
      function (e) {
        var sw = e.target && e.target.closest && e.target.closest('.ezink-pdp-swatch');
        if (!sw) return;
        schedule(sw.getAttribute('data-color') || '');
      },
      true
    );
    document.addEventListener('ezink-color-change', function (e) {
      var c = e && e.detail && e.detail.color;
      schedule(c || '');
    });
    if (window.jQuery) {
      jQuery(document).on('variantChange variantImageChange', function (evt) {
        var c = colorFromVariant(evt && evt.variant, inv.optionNames);
        schedule(c || '');
      });
    }
    var mo = new MutationObserver(function () { schedule(); });
    function observe() {
      var root = liveRoot(sectionId);
      var label = root.querySelector('[data-ezink-selected-color]');
      var sel = root.querySelector('[data-ezink-color-select]');
      try {
        if (label) mo.observe(label, { characterData: true, childList: true, subtree: true });
        if (sel) mo.observe(sel, { attributes: true, attributeFilter: ['value'] });
      } catch (err) {}
    }
    function lockAtc() {
      var label = (window.theme && theme.strings && theme.strings.addToCart) || "Add to cart";
      liveRoot(sectionId).querySelectorAll("[data-add-to-cart]").forEach(function (btn) {
        btn.disabled = false;
        btn.removeAttribute("disabled");
        btn.removeAttribute("aria-disabled");
        btn.classList.remove("disabled");
        btn.setAttribute("aria-label", label);
        var t = btn.querySelector("[data-add-to-cart-text]");
        if (t && t.textContent.trim() !== label) t.textContent = label;
      });
    }

    observe();
    setInterval(function () {
      var grid = liveRoot(sectionId).querySelector('[data-ezink-size-qty-grid]');
      var c = liveColor(sectionId, inv.optionNames);
      if (grid && c && grid.getAttribute('data-ezink-size-qty-color') !== c) paint(c);
      lockAtc();
    }, 150);
    paint();
    schedule();
    lockAtc();
    if (window.jQuery) {
      jQuery(document).on("variantChange", function () { setTimeout(lockAtc, 0); setTimeout(lockAtc, 60); });
    }
    window.ezinkPaintSizeQtyStock = paint;
  }

  function boot() {
    var sizeQty = document.querySelector('[data-ezink-size-qty]');
    var el = document.querySelector('[id^="VariantInventory-"]');
    var sectionId = '';
    if (el) sectionId = el.id.replace('VariantInventory-', '');
    else if (sizeQty) {
      var wrap = sizeQty.closest('[id^="ProductSection-"]');
      if (wrap && wrap.id) sectionId = wrap.id.replace('ProductSection-', '');
    }
    var jsonEl = sectionId ? document.getElementById('VariantInventoryJson-' + sectionId) : null;
    if (sizeQty) {
      if (el) {
        el.style.display = 'none';
        el.setAttribute('data-ezink-skip-inventory', 'true');
      }
      bindSizeQtyStock(sectionId);
      return;
    }
    if (!el) return;
    jsonEl = document.getElementById('VariantInventoryJson-' + sectionId);
    var textEl = el.querySelector('[data-inventory-text]');
    if (!jsonEl || !textEl) return;

    var data = {};
    try {
      data = JSON.parse((jsonEl.textContent || '').trim() || '{}');
    } catch (e) {
      data = {};
    }
    if (data && data.skip) {
      el.style.display = 'none';
      return;
    }

    var qtyMap = {};
    var byOptions = {};
    if (data && data.qty && typeof data.qty === 'object') {
      qtyMap = data.qty;
      byOptions = data.byOptions || {};
    } else {
      qtyMap = data || {};
    }

    if (!byOptions || !Object.keys(byOptions).length) {
      byOptions = {};
      var productJsonEl = document.getElementById('ProductJson-' + sectionId);
      if (productJsonEl) {
        try {
          var prod = JSON.parse((productJsonEl.textContent || '').trim() || '{}');
          (prod.variants || []).forEach(function (v) {
            var key = (v.options || []).join('|');
            if (key) byOptions[key] = String(v.id);
          });
        } catch (e2) {}
      }
    }

    var hasByOptions = byOptions && Object.keys(byOptions).length > 0;
    var threshold = parseInt(el.getAttribute('data-inventory-threshold') || '1000', 10) || 1000;

    function formatQty(n) {
      try { return Number(n).toLocaleString(); } catch (e) { return String(n); }
    }
    function qtyForId(id) {
      if (id == null || id === '') return null;
      var key = String(id);
      if (Object.prototype.hasOwnProperty.call(qtyMap, key)) return qtyMap[key];
      if (key.indexOf('/') !== -1) {
        var tail = key.split('/').pop();
        if (Object.prototype.hasOwnProperty.call(qtyMap, tail)) return qtyMap[tail];
      }
      return null;
    }
    function selectedOptionValues() {
      var root = document.getElementById('ProductSection-' + sectionId) || document;
      var vals = [];
      root.querySelectorAll('.single-option-selector, .single-option-selector-' + sectionId).forEach(function (sel) {
        vals.push(sel.value);
      });
      return vals;
    }
    function optionKey() {
      return selectedOptionValues().join('|');
    }
    function resolveVariantId() {
      var opts = selectedOptionValues();
      var key = optionKey();
      if (hasByOptions && opts.length) {
        if (byOptions[key]) return String(byOptions[key]);
        return null;
      }
      var select = document.getElementById('ProductSelect-' + sectionId);
      if (select && select.value) return String(select.value);
      var hidden = document.querySelector('#ProductSection-' + sectionId + ' [name="id"]');
      if (hidden && hidden.value) return String(hidden.value);
      if (key && byOptions[key]) return String(byOptions[key]);
      return null;
    }
    function showUnavailable(msg) {
      textEl.innerHTML = msg || 'Unavailable for this color/size';
      el.style.display = '';
      el.style.color = '#b30000';
    }
    function update(variantId, available) {
      if (!variantId) {
        showUnavailable('Unavailable for this color/size');
        return;
      }
      var qty = qtyForId(variantId);
      if (qty === null || typeof qty === 'undefined') {
        if (available === false) {
          showUnavailable('Unavailable for this color/size');
          return;
        }
        textEl.innerHTML = '';
        el.style.display = 'none';
        return;
      }
      qty = parseInt(qty, 10);
      if (isNaN(qty)) {
        el.style.display = 'none';
        return;
      }
      el.style.display = '';
      if (available === false) {
        showUnavailable(
          qty <= 0 ? 'Out of stock for this color/size' : 'Unavailable for this color/size'
        );
        return;
      }
      if (qty <= 0) {
        textEl.innerHTML = 'Out of stock for this color/size';
        el.style.color = '#b30000';
      } else if (qty < threshold) {
        textEl.innerHTML = '<strong>' + formatQty(qty) + '</strong> available for this color/size';
        el.style.color = qty < 50 ? '#b30000' : '#1a1a1a';
      } else {
        textEl.innerHTML = '<strong>1,000+</strong> available for this color/size';
        el.style.color = '#64748b';
      }
    }
    function refresh() {
      var opts = selectedOptionValues();
      var key = optionKey();
      if (hasByOptions && opts.length >= 2 && key && !byOptions[key]) {
        showUnavailable('Unavailable for this color/size');
        return;
      }
      var id = resolveVariantId();
      if (!id) {
        if (opts.length >= 2) showUnavailable('Unavailable for this color/size');
        return;
      }
      var available = true;
      var select = document.getElementById('ProductSelect-' + sectionId);
      if (select) {
        if (!select.value) available = false;
        else if (select.selectedIndex >= 0) {
          var t = select.options[select.selectedIndex].textContent || '';
          if (/sold out|unavailable/i.test(t)) available = false;
        }
      }
      if (hasByOptions && key && byOptions[key]) id = String(byOptions[key]);
      if (hasByOptions && key && !byOptions[key]) {
        showUnavailable('Unavailable for this color/size');
        return;
      }
      update(id, available);
    }

    var container = document.getElementById('ProductSection-' + sectionId);
    if (container && window.jQuery) {
      jQuery(container).on('variantChange', function (evt) {
        if (!evt || !evt.variant || !evt.variant.id) {
          showUnavailable('Unavailable for this color/size');
          setTimeout(refresh, 0);
          return;
        }
        var key = optionKey();
        if (hasByOptions && key && !byOptions[key]) {
          showUnavailable('Unavailable for this color/size');
          return;
        }
        update(String(evt.variant.id), evt.variant.available !== false);
      });
    }
    document.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (!t) return;
        if (
          (t.classList && t.classList.contains('single-option-selector')) ||
          t.name === 'id' ||
          (t.id && (t.id.indexOf('ProductSelect-') === 0 || t.id.indexOf('SingleOptionSelector') === 0))
        ) {
          setTimeout(refresh, 0);
          setTimeout(refresh, 50);
          setTimeout(refresh, 200);
        }
      },
      true
    );

    var last = '';
    setInterval(function () {
      var sig = (resolveVariantId() || '') + '::' + optionKey();
      if (sig !== last) {
        last = sig;
        refresh();
      }
    }, 150);

    refresh();
    setTimeout(refresh, 100);
    setTimeout(refresh, 400);
  }

  ready(boot);
})();
